import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { SnackbarProvider as NotistackProvider } from "notistack";
import React, { createRef } from "react";
const notistackRef = createRef();
const onClickDismiss = (key) => () => {
    var _a;
    (_a = notistackRef === null || notistackRef === void 0 ? void 0 : notistackRef.current) === null || _a === void 0 ? void 0 : _a.closeSnackbar(key);
};
export default function SnackbarProvider({ children }) {
    return (React.createElement(NotistackProvider, { anchorOrigin: { horizontal: "center", vertical: "top" }, autoHideDuration: 3000, ref: notistackRef, action: (key) => (React.createElement(IconButton, { "aria-label": "close", color: "inherit", onClick: onClickDismiss(key) },
            React.createElement(CloseIcon, null))) }, children));
}
//# sourceMappingURL=index.js.map